'use client';

import Script from 'next/script';

type MarketoScriptProps = {
  baseUrl: string;
};

/**
 * Component that loads the Marketo Forms2 script
 */
export const MarketoScript = ({ baseUrl }: MarketoScriptProps) => {
  return (
    <Script
      id="mkto-forms2-script"
      src={`${baseUrl}/js/forms2/js/forms2.min.js`}
      strategy="afterInteractive"
      onLoad={() => {
        if (typeof window !== 'undefined') {
          window.dispatchEvent(new Event('mkto-forms2-loaded'));
        }
      }}
    />
  );
};
